import * as classroomActions from './classroom/classroomActions';
import { getUpdatedParticipantsPresence } from '../services/presence/presenceService';

export const updateParticipantsPresence = connected => (dispatch, getState) => {
  const participants = getState().classrooms.selectedClassroom.participants;
  const participantConnected = connected.participant;
  const updatedParticipants = getUpdatedParticipantsPresence(participants, participantConnected);
  dispatch(classroomActions.setClassroomParticipants(updatedParticipants));
};
